import { createSlice } from "@reduxjs/toolkit";
import {
  getAcceptedCookiesList,
  getCookiesInSession,
  setCookiesInSession,
} from "../../../cookies/config/cookies.config";

const slice = createSlice({
  name: "cookies",
  initialState: {
    cookies: { title: "", acceptedCookies: [], options: getCookiesInSession() },
  },
  reducers: {
    loadCookiesSuccess: (state, action) => {
      const { payload } = action;
      let cookies = payload ? payload : null;
      const cookiesIntoStore =
        state.cookies.options.length && cookies
          ? {
              ...cookies,
              options: cookies.options.map((opt) => {
                const cookieValue = state.cookies.options.find((el) => el.related.id == opt.related.id);
                return {
                  ...opt,
                  default_check: cookieValue ? cookieValue.default_check : opt.default_check,
                };
              }),
            }
          : cookies;
      setCookiesInSession(cookiesIntoStore);
      return {
        cookies: { ...cookiesIntoStore, acceptedCookies: getAcceptedCookiesList(cookiesIntoStore.options) },
      };
    },
    setAllCookiesTrueSuccess: (state, action) => {
      const cookiesToSet = {
        ...state.cookies,
        options: state.cookies.options.map((opt) => ({
          ...opt,
          default_check: true,
        })),
      };
      setCookiesInSession(cookiesToSet);
      return { cookies: { ...cookiesToSet, acceptedCookies: getAcceptedCookiesList(cookiesToSet.options) } };
    },
    setCookiesWithoutBannerSuccess: (state) => {
      const cookiesToSet = {
        ...state.cookies,
        options: state.cookies.options.map((opt) => {
          if (opt.related.id == "hpy_marketing_cookies") {
            return {
              ...opt,
              default_check: false,
            };
          } else
            return {
              ...opt,
              default_check: true,
            };
        }),
      };
      setCookiesInSession(cookiesToSet);
      return { cookies: { ...cookiesToSet, acceptedCookies: getAcceptedCookiesList(cookiesToSet.options) } };
    },
    changeCookiesOptionsSuccess: (state, { payload }) => {
      const updatedCookies = {
        ...payload,
        options: payload.options.map((opt) => {
          if (opt.related.id == "hpy_cookies_have_been_accepted") {
            return {
              ...opt,
              default_check: true,
            };
          } else return opt;
        }),
      };
      setCookiesInSession(updatedCookies);
      return { cookies: { ...updatedCookies, acceptedCookies: getAcceptedCookiesList(updatedCookies.options) } };
    },
  },
});

export const loadCookies = (data) => async (dispatch) => {
  try {
    dispatch(loadCookiesSuccess(data));
  } catch (e) {
    return console.error(e.message);
  }
};

export const changeCookiesOptions = (data) => async (dispatch) => {
  try {
    dispatch(changeCookiesOptionsSuccess(data));
  } catch (e) {
    return console.error(e.message);
  }
};
export const setAllCookiesTrue = (data) => async (dispatch) => {
  try {
    dispatch(setAllCookiesTrueSuccess(data));
  } catch (e) {
    return console.error(e.message);
  }
};

export const setCookiesWithoutBanner = (data) => async (dispatch) => {
  try {
    dispatch(setCookiesWithoutBannerSuccess(data));
  } catch (e) {
    return console.error(e.message);
  }
};

const { actions, reducer } = slice;

export const {
  loadCookiesSuccess,
  setAllCookiesTrueSuccess,
  changeCookiesOptionsSuccess,
  setCookiesWithoutBannerSuccess,
} = actions;

export default reducer;
